import { secureStorage } from '../utils/secureStorage';
import { BACKEND_URL } from '../utils/backendUrl';
/**
 * Ambassador Pack V4 API Integration
 * Handles all API calls for Ambassador Pack V4 CRUD operations
 */

/**
 * Get authentication token from localStorage
 */
const getAuthToken = () => {
  return secureStorage.getItem('nexus_access_token');
};

/**
 * Create new Ambassador Pack V4
 */
export const createAmbassadorPackV4 = async (packData) => {
  const token = getAuthToken();
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(packData)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to create ambassador pack');
  }
  
  return response.json();
};

/**
 * List all Ambassador Packs V4 with optional filters
 */
export const listAmbassadorPacksV4 = async (filters = {}) => {
  const token = getAuthToken();
  
  // Build query params
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.category) params.append('category', filters.category);
  if (filters.ambassador_type) params.append('ambassador_type', filters.ambassador_type);
  if (filters.tags) params.append('tags', filters.tags);
  
  const queryString = params.toString() ? `?${params.toString()}` : '';
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs${queryString}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to list ambassador packs');
  }
  
  return response.json();
};

/**
 * Get single Ambassador Pack V4 by ID
 */
export const getAmbassadorPackV4 = async (packId) => {
  const token = getAuthToken();
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs/${packId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to get ambassador pack');
  }
  
  return response.json();
};

/**
 * Update Ambassador Pack V4 by section or all
 */
export const updateAmbassadorPackV4 = async (packId, updates, section = 'all') => {
  const token = getAuthToken();
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs/${packId}?section=${section}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to update ambassador pack');
  }
  
  return response.json();
};

/**
 * Delete Ambassador Pack V4
 */
export const deleteAmbassadorPackV4 = async (packId) => {
  const token = getAuthToken();
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs/${packId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to delete ambassador pack');
  }
  
  return response.json();
};

/**
 * Publish Ambassador Pack V4
 */
export const publishAmbassadorPackV4 = async (packId) => {
  const token = getAuthToken();
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs/${packId}/publish`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to publish ambassador pack');
  }
  
  return response.json();
};

/**
 * Unpublish Ambassador Pack V4
 */
export const unpublishAmbassadorPackV4 = async (packId) => {
  const token = getAuthToken();
  
  const response = await fetch(`${BACKEND_URL}/api/v4/ambassador-packs/${packId}/unpublish`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to unpublish ambassador pack');
  }
  
  return response.json();
};
